export default __webpack_public_path__ + "assets/images/149a1ce44aba17baa9dda28bdd5ed4b3.png";